import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

export const DEMO_INVOICE_VISIBLE_COLUMNS: InvoiceLineColumn[] = [
  'description',
  'quantity',
  'unit',
  'unitPrice',
  'vatPct',
  'total',
]

export const DEMO_INVOICE_VISIBLE_COLUMNS_WITH_DISCOUNT: InvoiceLineColumn[] = [
  ...DEMO_INVOICE_VISIBLE_COLUMNS,
  'discount',
  'discountPct',
]
